<template>
  <section>
    <div class="auth-wrapper auth-v2">
      <b-row class="auth-inner m-0">
        <b-col
        lg="5"
        class="d-flex align-items-center auth-bg px-2 p-lg-5"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
        >
          <slot name="card"></slot>
        </b-col>
      </b-col>
      <b-col
        lg="7"
        class="d-none d-lg-flex align-items-center" 
        style="padding-top:4em; padding-bottom:4em;"
      >
        <b-carousel
          id="carousel-1"
          v-model="slide"
          :interval="4000"
          background="none"
          style="text-shadow: 1px 1px 2px #333; width: 90%"
        >
          <b-carousel-slide>
            <div style="color: #fff; text-align: left;">
              <p>"A fit body, a calm mind, a house full of love. These things cannot be bought - they must be earned"</p>
              <span>- Naval Ravikant</span>
            </div>
            <div style="text-align:right;">
              <span class="mr-2" @click="slide -= 1"><feather-icon icon="ArrowLeftCircleIcon" size="20" /></span>
              <span @click="slide += 1"><feather-icon icon="ArrowRightCircleIcon" size="20" /></span>
            </div>
            <template #img>
              <b-img
                class="d-block img-fluid w-100"
                fluid
                :src="imgUrl"
                style="height: 90vh; width: 90%;"
                alt="Login V2"
              />
            </template>
          </b-carousel-slide>


          <b-carousel-slide>
            <div style="color: #fff; text-align: left;">
              <p>"Time and health are two precious assets that we don't recognize and appreciate until they have been depleted."</p>
              <span>- Denis Waitley</span>
            </div>
            <div style="text-align:right;">
              <span class="mr-2" @click="slide -= 1"><feather-icon icon="ArrowLeftCircleIcon" size="20" /></span>
              <span @click="slide += 1"><feather-icon icon="ArrowRightCircleIcon" size="20" /></span>
            </div>
            <template #img>
            
              <b-img
                class="d-block img-fluid w-100"
                fluid
                :src="insurancePolicyImage"
                style="height: 90vh; width: 90%;"
                alt="Login V2"
              />
            </template>
          </b-carousel-slide>

          <b-carousel-slide>
            <div style="color: #fff; text-align: left;">
              <p>"It is health that is real wealth and not pieces of gold and silver."</p>
              <span>- Mahatma Gandhi</span>

            </div>
            <div style="text-align:right;">
              <span class="mr-2" @click="slide -= 1"><feather-icon icon="ArrowLeftCircleIcon" size="20" /></span>
              <span @click="slide += 1"><feather-icon icon="ArrowRightCircleIcon" size="20" /></span>
            </div>
            <template #img>
              <b-img
                class="d-block img-fluid w-100"
                fluid
                :src="verificationImage"
                style="height: 90vh; width: 90%;"
                alt="Login V2"
              />
            </template>
          </b-carousel-slide>
          

          <b-carousel-slide>
            <div style="color: #fff; text-align: left;">
              <p>"Take care of your body. It's the only place you have to live."</p>
              <span>- Jim Rohn</span>
            </div>
            <div style="text-align:right;">
              <span class="mr-2" @click="slide -= 1"><feather-icon icon="ArrowLeftCircleIcon" size="20" /></span>
              <span @click="slide += 1"><feather-icon icon="ArrowRightCircleIcon" size="20" /></span>
            </div>
            <template #img>
              <b-img
                class="d-block img-fluid w-100"
                fluid
                :src="accountCreationImage"
                style="height: 90vh; width: 90%;"
                alt="Login V2"
              />
            </template>
          </b-carousel-slide>

          <b-carousel-slide>
            <div style="color: #fff; text-align: left;">
              <p>"Health is the greatest gift, contentment the greatest wealth, faithfulness the best relationship."</p>
              <span>- Buddha</span>
            </div>
            <div style="text-align:right;">
              <span class="mr-2" @click="slide -= 1"><feather-icon icon="ArrowLeftCircleIcon" size="20" /></span>
              <span @click="slide += 1"><feather-icon icon="ArrowRightCircleIcon" size="20" /></span>
            </div>
            <template #img>
              <b-img
                class="d-block img-fluid w-100"
                fluid
                :src="resetPasswordImage"
                style="height: 90vh; width: 90%;"
                alt="Login V2"
              />
            </template>
          </b-carousel-slide>

        </b-carousel>
      </b-col>

     
    </b-row>
    </div>
  </section>
</template>

<script>
import { BOverlay, BLink, BRow, BCol, BImg, BCarousel, BCarouselSlide } from "bootstrap-vue";
import BottomDesign from '@/assets/svg/BottomDesign.svg';
import LoginImage from '@/assets/images/login.png';
import InsurancePolicyImage from '@/assets/images/insurance_policy.png';
import VerificationImage from '@/assets/images/verification.png';
import AccountCreationImage from '@/assets/images/account_creation.png';
import ResetPasswordImage from '@/assets/images/reset_password.png';

export default {
  name: "AuthWrapper",
  components: {
    BLink,
    BOverlay,
    BottomDesign,
    BRow, 
    BCol, 
    BImg,
    BCarousel,
    BCarouselSlide,
  },
  data() {
    return {
      // eslint-disable-next-line global-require
      sideImg: LoginImage,
      slide: 0,
      sliding: null,
      insurancePolicyImage: InsurancePolicyImage,
      verificationImage: VerificationImage,
      accountCreationImage: AccountCreationImage,
      resetPasswordImage: ResetPasswordImage,

    }
  },
  computed: {
    imgUrl() {
      return this.sideImg
    },
  },

  
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';

.carousel-caption{
  left: 3% !important;
  right: 5% !important
}
</style>
